import React from "react";
import "./pickup_320.css";

export default function Pickup320Card({ onSelect }) {
  return (
    <div className="pkg-card pickup-320">
      <div className="pkg-body">
        <h3>MSIG Pickup คอกเสมอหัวเก๋ง 320</h3>
        <p>ประกันภัยประเภท 1 — กระบะบรรทุก ≤4 ตัน (ซ่อมอู่)</p>

        <ul className="pkg-list">
          <li>รหัส 320 : Pickup มีคอก / โครงเหล็กเสมอหลังคา</li>
          <li>อายุรถ 2–12 ปี</li>
          <li>รวมส่วนลด CCTV แล้ว</li>
          <li>คุ้มครองอุปกรณ์ตกแต่ง ≤ 20,000 บาท</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>
          ดูรายละเอียด
        </button>
      </div>
    </div>
  );
}
